import React, { useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Routes } from 'routes'
import { Agency } from 'types/agency'
import { AppContext } from 'contexts/AppContext'
import { canManageDispositions } from 'constant/authorization'
import TsxUtils from 'utils/tsx'
import './AgencyTabs.scss'

interface AgencyTabsProps {
  agencyId: Agency['id']
}

const AgencyTabs: React.FC<AgencyTabsProps> = ({ agencyId }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { allowedFor } = useContext(AppContext)

  const tabs = [
    { id: 'form', label: t('agencies.tabs.data'), url: Routes.AGENCIES.EDIT(agencyId) },
    ...(canManageDispositions(allowedFor)
      ? [
          {
            id: 'dispositions',
            label: t('agencies.tabs.dispositions'),
            url: Routes.AGENCIES.DISPOSITIONS(agencyId),
          },
        ]
      : []),
  ]

  if (tabs.length < 2) {
    return null
  }

  return (
    <div className='AgencyTabs'>
      {tabs.map(tab => (
        <button
          key={tab.id}
          data-cy={`agency-tab-${tab.id}`}
          type='button'
          className={
            'AgencyTabs__tab' + TsxUtils.extraStyle(pathname === tab.url, 'AgencyTabs__tab--active')
          }
          onClick={() => navigate(tab.url)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}

export default AgencyTabs
